module.exports = __webpack_public_path__ + "img/4-2.c9db8500.jpg";